import { createContext, useContext } from 'react';
import { ElectronWindowsMessagingService } from '@web-chat-core/toolkit';

export type AppEnvironment = {
    multiWindowMessagingService?: ElectronWindowsMessagingService;
};

export const AppEnvironmentContext = createContext<AppEnvironment | null>(null);
export const AppEnvironmentProvider = AppEnvironmentContext.Provider;

export const useAppEnvironmentProvider = () => {
    const appEnvironment = useContext(AppEnvironmentContext);

    if (!appEnvironment) {
        throw new Error('AppEnvironment context is not added to react tree');
    }

    return appEnvironment;
};
